import React, { MouseEvent, ReactElement, ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { StyledMenuLink } from './StyledMenuLink';
import { localizedPath } from '../helpers/localizedPath';

type AnchoredLinkProps = {
  anchor: string;
  children: ReactNode;
  onClick?: () => void;
  color: string;
};

export const AnchoredLink = (props: AnchoredLinkProps): ReactElement => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleClick = (event: MouseEvent) => {
    event.preventDefault();
    const anchorTarget = document.getElementById(props.anchor);

    if (anchorTarget) {
      anchorTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      // The section lives on the home page, e.g. when the link is used from the
      // consulting page. AppLayout scrolls to the hash once the page is rendered.
      navigate(`${localizedPath(pathname, '/')}#${props.anchor}`);
    }

    if (props.onClick) {
      props.onClick();
    }
  };

  return (
    <StyledMenuLink href={`#${props.anchor}`} onClick={handleClick} color={props.color}>
      {props.children}
    </StyledMenuLink>
  );
};
